import checkAuthenticated from '@/router/middlewares/checkAuthenticated';
import beforeEnterCheck from '@/router/middlewares/beforeEnterCheck';
import DECORATION_TYPES from '@/router/enums/DECORATION_TYPES';

export default [
  {
    path: '/registryitems',
    name: 'RegistryView',
    component: () =>
      import(
        /* webpackChunkName: "registry-view" */ '@/modules/registry/components/RegistryView'
      ),
    meta: {
      moduleId: 'registry',
      decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
    },
    beforeEnter: checkAuthenticated,
  },
  {
    path: '/registryitems/:id',
    name: 'RegistryForm',
    component: () =>
      import(
        /* webpackChunkName: "registry-form" */ '@/modules/registry/components/RegistryForm'
      ),
    meta: { moduleId: 'registry' },
    props: true,
    beforeEnter: beforeEnterCheck,
  },
  {
    path: '/configurations',
    name: 'ConfigurationsView',
    component: () =>
      import(
        /* webpackChunkName: "configurations-view" */ '@/modules/config_fixtures/components/ConfigurationsView'
      ),
    meta: {
      moduleId: 'fixtures',
    },
    beforeEnter: checkAuthenticated,
  },
  {
    path: '/attributecategories',
    name: 'AttributeCategoriesView',
    component: () =>
      import(
        /* webpackChunkName: "attributes-view" */ '@/modules/attributes/components/AttributeCategoriesView'
      ),
    meta: {
      moduleId: 'attributecategories',
    },
    beforeEnter: checkAuthenticated,
  },
  {
    path: '/attributecategories/:id',
    name: 'AttributeCategoryForm',
    component: () =>
      import(
        /* webpackChunkName: "attributes-form" */ '@/modules/attributes/components/AttributeCategoryForm'
      ),
    meta: {
      moduleId: 'attributecategories',
    },
    props: true,
    beforeEnter: beforeEnterCheck,
  },
  {
    path: '/users/notificationConfigurationSchedulings/:id',
    name: 'NotificationConfigurationOwnItem',
    component: () =>
      import(
        /* webpackChunkName: "notification-configuration-own-item" */ '@/modules/notification_configuration/components/NotificationConfigurationOwnItem'
      ),
    meta: {
      moduleId: 'notificationConfiguration',
      ignoreModuleCheck: true,
    },
    props: true,
    beforeEnter: checkAuthenticated,
  },
  {
    path: '/addressperson/:addresspersonId/notificationConfigurationSchedulings/:id',
    name: 'NotificationConfigurationAddressPersonItem',
    component: () =>
      import(
        /* webpackChunkName: "notification-configuration-address-person-item" */ '@/modules/notification_configuration/components/NotificationConfigurationAddressPersonItem'
      ),
    meta: {
      moduleId: 'notificationConfiguration',
      ignoreModuleCheck: true,
    },
    props: true,
    beforeEnter: checkAuthenticated,
  },
  {
    path: '/notificationgroup/:notificationGroupId/notificationConfigurationSchedulings/:id',
    name: 'NotificationConfigurationNotificationItem',
    component: () =>
      import(
        /* webpackChunkName: "notification-configuration-notification-item" */ '@/modules/notification_configuration/components/NotificationConfigurationNotificationItem'
      ),
    meta: {
      moduleId: 'notificationConfiguration',
      ignoreModuleCheck: true,
    },
    props: true,
    beforeEnter: checkAuthenticated,
  },
  {
    path: '/occupationgroup/:occupationGroupId/notificationConfigurationSchedulings/:id',
    name: 'NotificationConfigurationOccupationGroupItem',
    component: () =>
      import(
        /* webpackChunkName: "notification-configuration-occupation-group-item" */ '@/modules/notification_configuration/components/NotificationConfigurationOccupationGroupItem'
      ),
    meta: {
      moduleId: 'notificationConfiguration',
      ignoreModuleCheck: true,
    },
    props: true,
    beforeEnter: checkAuthenticated,
  },
  {
    path: '/textblocks',
    name: 'TextBlockView',
    component: () =>
      import(
        /* webpackChunkName: "text-block-view" */ '@/modules/text_blocks/components/TextBlockView'
      ),
    meta: {
      moduleId: 'textblocks',
      decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
    },
    beforeEnter: checkAuthenticated,
  },
  {
    path: '/textblocks/:id',
    name: 'TextBlockForm',
    component: () =>
      import(
        /* webpackChunkName: "text-block-form" */ '@/modules/text_blocks/components/TextBlockForm'
      ),
    meta: {
      moduleId: 'textblocks',
    },
    props: true,
    beforeEnter: beforeEnterCheck,
  },
  {
    path: '/documents',
    name: 'DocumentsView',
    component: () =>
      import(
        /* webpackChunkName: "registry-view" */ '@/modules/documents/DocumentsView'
      ),
    meta: {
      moduleId: 'documents',
      decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
    },
    beforeEnter: checkAuthenticated,
  },
  {
    path: '/documents/:id',
    name: 'DocumentForm',
    component: () =>
      import(
        /* webpackChunkName: "registry-form" */ '@/modules/documents/DocumentForm'
      ),
    meta: { moduleId: 'documents' },
    props: true,
    beforeEnter: beforeEnterCheck,
  },
  {
    path: '/errorlogs',
    name: 'ErrorsView',
    component: () =>
      import(
        /* webpackChunkName: "error-view" */ '@/modules/error_analysis/ErrorsView'
      ),
    meta: { 
      moduleId: 'errorAnalysis',
      decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
    },
    beforeEnter: checkAuthenticated,
  },
  {
    path: '/errorlogs/:id',
    name: 'ErrorForm',
    component: () =>
      import(
        /* webpackChunkName: "error-form" */ '@/modules/error_analysis/ErrorForm'
      ),
    meta: { moduleId: 'errorAnalysis' },
    props: true,
    beforeEnter: beforeEnterCheck,
  },
  {
    path: '/adminConsole',
    name: 'AdminConsoleView',
    component: () =>
      import(
        /* webpackChunkName: "admin-console" */ '@/modules/admin_console/components/AdminConsoleView'
      ),
    meta: {
      moduleId: 'adminConsole',
    },
    beforeEnter: checkAuthenticated,
  },
];
